export default __webpack_public_path__ + "static/media/bg_blue.bc1f635e.jpg";